import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import config from "../../configuration/config";
import { useHistory } from "react-router";
import { RadioInput } from "../../components/_input/_radioInput";
import { CheckInput } from "../../components/_input/_checkInput";
import _ from "lodash";
import { Price } from "../../components/__simple/_price";
import "./OrderDetails.css";
// Premium checkout styles are imported through _pages.scss -> _premiumCheckout.scss

export function CarCheckoutPage({ vehicle, parmActiveModel, isToyota, isLexus, selectedColor, finance, financeSettings, filterCarImages = [] }) {
  const history = useHistory();
  const { slug, sn } = useParams();
  const { t: trans, i18n } = useTranslation(["new", "finance", "inputs", "info"]);
  const [scrollSnackUp, setScrollSnackUp] = useState({ show: false, height: "16rem" });
  const [showFinalPopup, setShowFinalPopup] = useState(false);
  const [showFinalPopupMessage, setShowFinalPopupMessage] = useState();
  const [activeModel, setActiveModel] = useState(parmActiveModel);
  const [propsData, setPropsData] = useState({});
  const [carInfo, setCarInfo] = useState(null);
  const [checkoutType, setCheckoutType] = useState(4);
  const [checkoutAgreemnt, setChecAgreemnt] = useState(false);

  const [purchaseCarMethods, setPurchaseCarMethods] = useState([]);
  useEffect(() => {
    const loadManifest = async () => {
      try {
        const url = `/config.json?v=${Date.now()}`;
        const response = await fetch(url);
        if (!response.ok) { throw new Error(`HTTP error! status: ${response.status}`); }
        const data = await response.json();
        const _purchaseCarMethods = data.purchaseCarMethods || [];
        const activeKeys = _purchaseCarMethods.filter((platform) => platform.isActive).map((platform) => platform.key);
        setPurchaseCarMethods(activeKeys);
      } catch (error) { console.error("Error loading json:", error); }
    };
    loadManifest();
  }, []);

  useEffect(() => {
    var mm = { ...propsData, vehicle, isToyota, isLexus, selectedColor, finance, financeSettings, filterCarImages };
    setPropsData(mm);
    if (selectedColor) setCarInfo({ ...selectedColor });
  }, [vehicle, isToyota, isLexus, selectedColor, finance, financeSettings, filterCarImages]);
  let lang = i18n.language || "ar";
  useEffect(() => { setActiveModel(parmActiveModel); }, [parmActiveModel]);
  useEffect(() => {
    if (activeModel && activeModel?.buyOnline != true) {
      setShowFinalPopupMessage(trans("new:chassisReserved"));
      setShowFinalPopup(true);
    }
  }, [activeModel]);
  return (
    <>
      <section className="checkout-premium">
        {/* <div className="premium-sticky-header z-50 sticky top-0 md:hidden mb-6 py-4 px-6 flex items-center w-full">
          <button onClick={() => history.goBack()} className="mr-4 w-10 h-10 flex items-center justify-center rounded-xl bg-gray-50 border border-gray-200 hover:border-[#18a94e] hover:text-[#18a94e] transition-all">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
          </button>
          <span className="text-lg font-bold text-[#111]">{trans("new:choose_method")}</span>
        </div> */}

        <div className="max-w-[1200px] mx-auto px-4 md:px-8 py-8 md:py-12 grid grid-cols-1 md:grid-cols-12 gap-8 relative">

          <div className="md:col-span-8 space-y-6">
            <div className="premium-card p-6 md:p-10">
              <div className="mb-8 flex items-center justify-between">
                <div>
                  <div className="text-[11px] font-bold uppercase tracking-widest text-[#18a94e] mb-2 flex items-center gap-2">
                    <span className="w-5 h-0.5 bg-[#18a94e] rounded-full"></span> {trans("new:select_option")}
                  </div>
                  <h3 className="sh-title">{trans("new:choose_method")}</h3>
                </div>
              </div>

              <div className="space-y-5">
                {/* Option 1: Quick Booking */}
                {purchaseCarMethods?.includes("quick_booking") && (
                  <label className={`premium-option p-6 flex flex-col md:flex-row gap-6 cursor-pointer ${checkoutType == 4 ? "selected" : ""}`}>
                    <div className="pt-1">
                      <RadioInput value1={4} name="recieveMethod" selectValue={checkoutType} onChangeValue={() => setCheckoutType(4)} />
                    </div>
                    <div className="flex-1 flex flex-col justify-between">
                      <div>
                        <div className="flex items-center justify-between mb-2">
                          <h4 className="opt-title">{trans("new:Quick_Booking")}</h4>
                          <span className="opt-badge">{trans("new:top_choice")}</span>
                        </div>
                        {lang == "ar" ? (
                          <p className="opt-desc">{trans("احجز سيارتك الان بدفعة مقدمة واستكمل الشراء عبر الفرع او من خلال حسابك اون لاين")}</p>
                        ) : (
                          <p className="opt-desc">{trans("Reserve your car now with a down payment and complete the purchase at the branch or through your online account")}</p>
                        )}
                        <ul className="mt-3 space-y-1 z-10 relative">
                          <li className="flex items-center gap-2 text-2xl font-medium text-[#444]"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#18a94e" strokeWidth="2"><path d="M5 12l5 5L20 7" /></svg>{lang == "ar" ? trans("أسرع طريقة لاستلام سيارتك") : trans("The fastest way to receive your car")}</li>
                          <li className="flex items-center gap-2 text-2xl font-medium text-[#444]"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#18a94e" strokeWidth="2"><path d="M5 12l5 5L20 7" /></svg>{lang == "ar" ? trans("تثبيت السعر حتى استكمال الشراء") : trans("Lock the price until the purchase is completed")}</li>
                          <li className="flex items-center gap-2 text-2xl font-medium text-[#444]"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#18a94e" strokeWidth="2"><path d="M5 12l5 5L20 7" /></svg>{lang == "ar" ? trans("مدة حجز المركبة يوم عمل واحد") : "Vehicle booking duration: 1 business day"}</li>
                        </ul>
                      </div>
                    </div>
                    <div className="flex flex-row md:flex-col items-center md:items-end justify-between md:justify-start border-t border-gray-100 md:border-t-0 pt-4 md:pt-0">
                      <div className="opt-price">
                        {(isToyota && isToyota ? 2500 : isLexus ? 5000 : selectedColor?.MiniDownPayment) && (
                          <Price price={parseFloat(isToyota && isToyota ? 2500 : isLexus ? 5000 : selectedColor?.MiniDownPayment)} />
                        )}
                      </div>
                      <span className="text-[12px] font-bold text-[#8a8f99] uppercase tracking-wider">{trans("new:Refundable")}</span>
                    </div>
                  </label>
                )}

                {/* Option 2: Cash */}
                {purchaseCarMethods?.includes("cash") && (
                  <label className={`premium-option p-6 flex flex-col md:flex-row gap-6 cursor-pointer ${checkoutType == 1 ? "selected" : ""}`}>
                    <div className="pt-1">
                      <RadioInput value1={1} name="recieveMethod" selectValue={checkoutType} onChangeValue={() => setCheckoutType(1)} />
                    </div>
                    <div className="flex-1 flex flex-col justify-between">
                      <div>
                        <h4 className="opt-title">{trans("new:cash")}</h4>
                        <p className="opt-desc">{lang == "ar" ? trans("أسرع طريقة لاستلام سيارتك") : trans("The fastest way to receive your car")}</p>
                        <ul className="mt-3 space-y-1 z-10 relative">
                          <li className="flex items-center gap-2 text-2xl font-medium text-[#444]"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#18a94e" strokeWidth="2"><path d="M5 12l5 5L20 7" /></svg>{lang == "ar" ? trans("تثبيت السعر حتى استكمال الشراء") : trans("Lock the price until the purchase is completed")}</li>
                          <li className="flex items-center gap-2 text-2xl font-medium text-[#444]"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#18a94e" strokeWidth="2"><path d="M5 12l5 5L20 7" /></svg>{lang == "ar" ? trans("مدة حجز المركبة 5 أيام عمل") : "Vehicle booking duration: 5 business days"}</li>
                        </ul>
                      </div>
                    </div>
                    <div className="flex flex-row md:flex-col items-center md:items-end justify-between md:justify-start border-t border-gray-100 md:border-t-0 pt-4 md:pt-0">
                      <div className="opt-price">{selectedColor?.MiniDownPayment && <Price price={parseFloat(selectedColor?.MiniDownPayment)} />}</div>
                      <span className="text-[12px] font-bold text-[#8a8f99] uppercase tracking-wider">{trans("new:Refundable")}</span>
                    </div>
                  </label>
                )}

                {/* Option 3: Financing */}
                {purchaseCarMethods?.includes("financing_request") && (
                  <label className={`premium-option p-6 flex flex-col md:flex-row gap-6 cursor-pointer ${checkoutType == 2 ? "selected" : ""}`}>
                    <div className="pt-1">
                      <RadioInput value1={2} name="recieveMethod" selectValue={checkoutType} onChangeValue={() => setCheckoutType(2)} />
                    </div>
                    <div className="flex-1">
                      <h4 className="opt-title">{trans("new:financing_request")}</h4>
                      <p className="opt-desc">{lang == "ar" ? trans("احصل على موافقة مبدئية خلال دقائق") : trans("Get an initial approval within minutes")}</p>
                      <ul className="mt-3 space-y-1 z-10 relative">
                        <li className="flex items-center gap-2 text-2xl font-medium text-[#444]"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#18a94e" strokeWidth="2"><path d="M5 16l5 5L20 7" /></svg>{lang == "ar" ? trans("خيارات متنوعة تناسب دخلك") : trans("A variety of options that suit your income")}</li>
                        <li className="flex items-center gap-2 text-2xl font-medium text-[#444]"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#18a94e" strokeWidth="2"><path d="M5 12l5 5L20 7" /></svg>{lang == "ar" ? trans("فريق تمويل متخصص يساعدك خطوة بخطوة") : trans("A specialized financing team helps you step by step")}</li>
                      </ul>
                    </div>
                    <div className="flex flex-row md:flex-col items-center md:items-end justify-between md:justify-start border-t border-gray-100 md:border-t-0 pt-4 md:pt-0">
                      <div className="opt-price uppercase tracking-widest text-[#111]">{trans("new:free")}</div>
                    </div>
                  </label>
                )}

                {/* Option 4: Contact Request */}
                {purchaseCarMethods?.includes("contact_request") && (
                  <label className={`premium-option p-6 flex flex-col md:flex-row gap-6 cursor-pointer ${checkoutType == 3 ? "selected" : ""}`}>
                    <div className="pt-1">
                      <RadioInput value1={3} name="recieveMethod" selectValue={checkoutType} onChangeValue={() => setCheckoutType(3)} />
                    </div>
                    <div className="flex-1">
                      <h4 className="opt-title">{trans("new:contact_request")}</h4>
                      <p className="opt-desc">{lang == "ar" ? trans("يتواصل معك مستشار مبيعات خلال دقائق (داخل أوقات العمل)") : trans("A sales consultant will contact you within minutes (during working hours)")}</p>
                      <ul className="mt-3 space-y-1 z-10 relative">
                        <li className="flex items-center gap-2 text-2xl font-medium text-[#444]"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#18a94e" strokeWidth="2"><path d="M5 12l5 5L20 7" /></svg>{lang == "ar" ? trans("يساعدك بمعرفة تفاصيل السيارة و أنسب العروض") : trans("Helps you learn about the car details and the best offers")}</li>
                      </ul>
                    </div>
                    <div className="flex flex-row md:flex-col items-center md:items-end justify-between md:justify-start border-t border-gray-100 md:border-t-0 pt-4 md:pt-0">
                      <div className="opt-price uppercase tracking-widest text-[#111]">{trans("new:free")}</div>
                    </div>
                  </label>
                )}
              </div>

              <div className="mt-10 pt-8 border-t border-[#efeeea] flex flex-col md:flex-row items-center justify-between gap-6">
                <div className="flex items-center gap-3">
                  <span className="z-10 relative"><CheckInput checked={checkoutAgreemnt} oncheng={() => setChecAgreemnt(!checkoutAgreemnt)} Name="check-agremnt" /></span>
                  <div className="text-2xl text-[#444] font-medium cursor-pointer" onClick={() => setChecAgreemnt(!checkoutAgreemnt)}>
                    {trans("new:terms_conditions")} <a className="text-[#18a94e] hover:underline mx-1 text-xl" href={`/${lang}/websitePolicy`} target="_blank" onClick={(e) => e.stopPropagation()}>{trans("new:website_policy")}</a>
                  </div>
                </div>

                <button
                  className={`premium-btn w-full md:w-auto min-w-[200px] ${checkoutType != null && checkoutAgreemnt ? "active" : "disabled"}`}
                  onClick={() => {
                    if (vehicle && checkoutType && checkoutAgreemnt == true && sn && slug) {
                      import("../../services/trackingCarEvents").then(GTM => {
                        const item = { item_id: vehicle?.productNo || vehicle?.slug, item_name: vehicle?.name, price: selectedColor?.NetSalePrice || 0, quantity: 1, item_brand: vehicle?.brand, item_category: vehicle?.group };
                        GTM.trackBeginCheckout(item, "SAR");
                      });
                      if (checkoutType == 1) history.push({ pathname: `/car/accessories/${sn}/${slug}`, search: "" });
                      else if (checkoutType == 2) history.push({ pathname: `/car/checkoutFinance/${sn}/${slug}`, search: "" });
                      else if (checkoutType == 3) history.push(`/order-car?vehicle=${vehicle?.productID}&model=${vehicle.year}&type=${vehicle.type}&color=${selectedColor?.ColorID}`);
                      else if (checkoutType == 4) history.push({ pathname: `/car/reservation/${sn}/${slug}`, search: "" });
                    }
                  }}>
                  {trans("new:continue")}
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                </button>
              </div >
            </div >
          </div >

          <div className="md:col-span-4 relative">
            <div className="premium-card p-6 md:p-8 sticky top-24">
              <h3 className="text-2xl font-bold text-[#111] mb-6 flex items-center gap-3">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                {trans("new:order_details")}
              </h3>

              {propsData?.vehicle ? (
                <div className="space-y-6">
                  <div className="img-container aspect-[4/3]">
                    <img alt={propsData?.vehicle?.brand} className="w-full h-full object-contain mix-blend-multiply drop-shadow-lg transition-transform duration-500 hover:scale-105" src={config.FilePathURL + (filterCarImages && filterCarImages.length > 0 ? filterCarImages[0]?.Image_URL : "")} />
                  </div>

                  <div>
                    <div className="flex items-center justify-between mb-2">
                      <h2 className="text-3xl font-bold text-[#111]">{propsData?.vehicle?.brand}</h2>
                      <img alt="" className="h-7 object-contain mix-blend-multiply" src={`/assets/icons/brands/${(isToyota ? "toyota" : "") + (isLexus ? "lexus" : "")}.webp`} />
                    </div>
                    <div className="text-3xl text-[#444] font-medium leading-relaxed">
                      {activeModel?.group} {activeModel?.modelDescription} {activeModel?.year}
                    </div>
                    {carInfo && (
                      <div className="mt-2 flex items-center gap-2 text-[13.5px] text-[#777] font-medium text-2xl">
                        <span className="w-6 h-6 rounded-full border shadow-sm border-gray-300" style={{ backgroundColor: carInfo.ColorHexCode || '#ccc' }}></span>
                        {carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[0]}
                        {carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[1] ? " / " + carInfo[lang == "ar" ? `ColorDescriptionAr` : `ColorDescriptionEn`]?.split("/")[1] : ''}
                      </div>
                    )}
                  </div>

                  <div className="h-px bg-[#efeeea] my-4"></div>

                  <div className="space-y-4">
                    <div className="flex items-center justify-between">
                      <div className="summary-label">{trans("new:cash_price")}</div>
                      <div className="summary-value drop-shadow-sm">
                        {selectedColor?.NetSalePrice && <Price price={parseFloat(selectedColor?.NetSalePrice)} style={{ color: "#32cc4f", fontSize: "26px" }} />}
                      </div>
                    </div>
                    <div className="flex items-center text-2xl justify-between text-[#777] text-[11px] font-medium tracking-wide">
                      <span>{trans("new:price_inclusive_note")}</span>
                    </div>

                    <div className="p-5 rounded-2xl bg-[rgba(24,169,78,.05)] border border-[rgba(24,169,78,.12)] mt-5 transition-colors hover:bg-[rgba(24,169,78,.08)]">
                      <div className="flex flex-col gap-1.5">
                        <span className="text-[12px] font-bold text-[#18a94e] uppercase tracking-wider">{trans("new:installment_starts")}</span>
                        <div className="flex items-end gap-1.5">
                          <span className="font-serif text-[24px] font-bold text-[#111] leading-none drop-shadow-sm">
                            {finance?.price && <Price price={parseFloat(finance?.price.toFixed(2))} style={{ color: "#32cc4f" }} />}
                          </span>
                          <span className="text-[13px] text-[#555] font-medium mb-1"> / {trans("new:monthly")}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="py-12 flex flex-col items-center justify-center text-center">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#efeeea" strokeWidth="2" className="mb-4"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line></svg>
                  <p className="text-[15px] text-[#8a8f99] font-medium">{trans("new:no_data")}</p>
                </div>
              )}
            </div>
          </div>
        </div >
      </section >
    </>
  );
}
